//axios
import axios from 'axios';
//utils
import { url } from 'utils/urls';

//headers
const withCredentials = true;
const headers = {
    "Content-Type": "application/json",
    'Accept': 'application/json',
};

export const asyncGetAddOns = siteUUID => axios.get(`${url.ccu.base}/v1/sites/${siteUUID}/add-ons`, { headers, withCredentials });

export const asyncCreateAddOnsSetting = ({path, request}) => axios.post(`${url.ccu.addOns}/${path}`, request, { headers, withCredentials });

export const asyncUpdateAddOnsSetting = ({path, request, configurationUUID}) => axios.put(`${url.ccu.addOns}/${path}/${configurationUUID}`, request, { headers, withCredentials });